import { render, staticRenderFns } from "./invoiceView.vue?vue&type=template&id=1a2b7467&"
import script from "./invoiceView.vue?vue&type=script&lang=js&"
export * from "./invoiceView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a2b7467')) {
      api.createRecord('1a2b7467', component.options)
    } else {
      api.reload('1a2b7467', component.options)
    }
    module.hot.accept("./invoiceView.vue?vue&type=template&id=1a2b7467&", function () {
      api.rerender('1a2b7467', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/entry/invoiceView.vue"
export default component.exports